
export default {
  pushData(data: any) {
    // @ts-ignore
    window.dataLayer = <any>window.dataLayer || [];
    // @ts-ignore
    window.dataLayer.push(data);
  },
};
